// src/views/fornecedores/FornecedorModal.jsx
import React, { useState, useEffect } from "react";
import { integracoesService } from "../../services/condominiosService";

const estadosBR = ["AC","AL","AP","AM","BA","CE","DF","ES","GO","MA","MT","MS","MG","PA","PB","PR","PE","PI","RJ","RN","RS","RO","RR","SC","SP","SE","TO"];

const fmtPhone = (v) => { const d = (v || "").replace(/\D/g, "").slice(0, 11); return d.length <= 10 ? d.replace(/^(\d{2})(\d{4})(\d{0,4})/, "($1) $2-$3").trim() : d.replace(/^(\d{2})(\d{5})(\d{0,4})/, "($1) $2-$3").trim(); };
const fmtCPF   = (v) => { const d = (v || "").replace(/\D/g, "").slice(0, 11); return d.replace(/(\d{3})(\d)/, "$1.$2").replace(/(\d{3})(\d)/, "$1.$2").replace(/(\d{3})(\d{1,2})$/, "$1-$2"); };
const fmtCNPJ  = (v) => { const d = (v || "").replace(/\D/g, "").slice(0, 14); return d.replace(/^(\d{2})(\d)/, "$1.$2").replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3").replace(/\.(\d{3})(\d)/, ".$1/$2").replace(/(\d{4})(\d)/, "$1-$2"); };
const fmtCEP   = (v) => { const d = (v || "").replace(/\D/g, "").slice(0, 8); return d.replace(/^(\d{5})(\d)/, "$1-$2"); };
const emailValido = (v) => !v || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);

const validaCPF = (v) => {
  const d = (v || "").replace(/\D/g, "");
  if (d.length !== 11 || /^(\d)\1+$/.test(d)) return false;
  let s = 0; for (let i = 0; i < 9; i++) s += parseInt(d[i], 10) * (10 - i);
  let r = (s * 10) % 11; if (r === 10 || r === 11) r = 0; if (r !== parseInt(d[9], 10)) return false;
  s = 0; for (let i = 0; i < 10; i++) s += parseInt(d[i], 10) * (11 - i);
  r = (s * 10) % 11; if (r === 10 || r === 11) r = 0; return r === parseInt(d[10], 10);
};
const validaCNPJ = (v) => {
  const d = (v || "").replace(/\D/g, "");
  if (d.length !== 14 || /^(\d)\1+$/.test(d)) return false;
  const calc = (n) => {
    let s = 0, p = n - 7;
    for (let i = 0; i < n; i++) { s += parseInt(d[i], 10) * p; p = p === 2 ? 9 : p - 1; }
    const r = s % 11;
    return r < 2 ? 0 : 11 - r;
  };
  return calc(12) === parseInt(d[12], 10) && calc(13) === parseInt(d[13], 10);
};

const EMPTY = {
  nmRazaoSocial: "", nmReduzido: "", tpPessoa: "Juridica", cpf_cnpj: "", inscEstadual: "", rg: "",
  ramoAtividade: "", telefone: "", celular: "", email: "", site: "", contato: "", observacao: "",
  cep: "", cidade: "", estado: "SP", bairro: "", endereco: "", numero: "", complemento: "",
  nrInss: "", nrPis: "", chavePix: "", codBanco: "", agencia: "", dgAgencia: "",
  contCorrente: "", dgContaCorrente: "", situacao: "ativo",
};

export default function FornecedorModal({ show, onClose, onSave, editData, saving = false, condominioNome = "", serverError = null, clearServerError }) {
  const isEdit = !!editData?.id;
  const [form, setForm]     = useState(EMPTY);
  const [errors, setErrors] = useState({});
  const [tab, setTab]       = useState("dados");
  const [cepLoading, setCepLoading] = useState(false);
  const [cnpjLoading, setCnpjLoading] = useState(false);
  const [cnpjMsg, setCnpjMsg] = useState(null);

  useEffect(() => {
    if (!show) return;
    setForm(editData ? { ...EMPTY, ...editData } : { ...EMPTY });
    setErrors({}); setTab("dados"); setCnpjMsg(null);
  }, [show, editData]);

  const set = (f, v) => {
    setForm((p) => ({ ...p, [f]: v }));
    setErrors((p) => ({ ...p, [f]: undefined }));
    if (clearServerError) clearServerError();
  };

  const fmtDoc = (v) => (form.tpPessoa === "Fisica" ? fmtCPF(v) : fmtCNPJ(v));

  const buscarCEP = async (raw) => {
    const cep = (raw || "").replace(/\D/g, ""); if (cep.length !== 8) return;
    setCepLoading(true);
    try {
      const r = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
      const d = await r.json();
      if (!d.erro) {
        setForm((p) => ({
          ...p,
          endereco: d.logradouro || p.endereco,
          bairro:   d.bairro || p.bairro,
          cidade:   d.localidade || p.cidade,
          estado:   d.uf || p.estado,
        }));
      }
    } catch { /* silencioso */ }
    setCepLoading(false);
  };

  const buscarCNPJ = async () => {
    if (form.tpPessoa !== "Juridica") return;
    const digits = (form.cpf_cnpj || "").replace(/\D/g, "");
    if (digits.length !== 14) {
      setCnpjMsg({ tp: "warn", msg: "Informe um CNPJ com 14 dígitos." });
      return;
    }
    setCnpjLoading(true); setCnpjMsg(null);
    try {
      const r = await integracoesService.consultarCnpj(digits);
      const d = r?.data || {};
      setForm((p) => ({
        ...p,
        nmRazaoSocial: d.razao_social || d.nome || p.nmRazaoSocial,
        nmReduzido:    d.nome_fantasia || p.nmReduzido,
        ramoAtividade: d.cnae_fiscal_descricao || d.atividade_principal?.[0]?.text || p.ramoAtividade,
        cep:           d.cep ? fmtCEP(d.cep) : p.cep,
        endereco:      d.logradouro ? `${d.logradouro}` : p.endereco,
        numero:        d.numero || p.numero,
        complemento:   d.complemento || p.complemento,
        bairro:        d.bairro || p.bairro,
        cidade:        d.municipio || p.cidade,
        estado:        d.uf || p.estado,
        email:         d.email || p.email,
        telefone:      d.ddd_telefone_1 ? fmtPhone(d.ddd_telefone_1) : p.telefone,
      }));
      setCnpjMsg({ tp: "ok", msg: "Dados preenchidos a partir da Receita Federal." });
    } catch (err) {
      setCnpjMsg({ tp: "err", msg: err.message || "Falha ao consultar CNPJ." });
    } finally {
      setCnpjLoading(false);
    }
  };

  const validate = () => {
    const e = {};
    if (!form.nmRazaoSocial.trim()) e.nmRazaoSocial = "Razão Social é obrigatória";
    if (form.cpf_cnpj?.trim()) {
      const ok = form.tpPessoa === "Juridica" ? validaCNPJ(form.cpf_cnpj) : validaCPF(form.cpf_cnpj);
      if (!ok) e.cpf_cnpj = form.tpPessoa === "Juridica" ? "CNPJ inválido" : "CPF inválido";
    }
    if (form.email && !emailValido(form.email)) e.email = "E-mail inválido";
    setErrors(e);
    if (Object.keys(e).length) { setTab("dados"); return false; }
    return true;
  };

  const handleSave = () => { if (validate()) onSave({ ...form, id: editData?.id }); };

  if (!show) return null;

  const tabs = [
    { id: "dados",     label: "Dados Gerais",   icon: "bi-building" },
    { id: "endereco",  label: "Endereço",        icon: "bi-geo-alt" },
    { id: "bancario",  label: "Dados Bancários", icon: "bi-bank" },
  ];

  return (
    <div className="modal fade show d-block" style={{ background: "rgba(0,0,0,.55)" }} tabIndex="-1">
      <div className="modal-dialog modal-xl modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            <div className="d-flex align-items-center gap-3">
              <div style={{ width: 38, height: 38, background: "rgba(255,255,255,.15)", borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center" }}>
                <i className="bi bi-truck" style={{ fontSize: 18, color: "#fff" }} />
              </div>
              <div>
                <h5 className="modal-title mb-0">{isEdit ? "Editar Fornecedor" : "Novo Fornecedor"}</h5>
                <small style={{ color: "rgba(255,255,255,.6)", fontSize: 12 }}>{condominioNome}</small>
              </div>
            </div>
            <button className="btn-close btn-close-white" onClick={onClose} />
          </div>

          <div style={{ background: "var(--primary)", padding: "0 24px" }}>
            <ul className="nav nav-tabs border-0" style={{ gap: 4 }}>
              {tabs.map((t) => (
                <li key={t.id} className="nav-item">
                  <button
                    className={`nav-link border-0 d-flex align-items-center gap-2 ${tab === t.id ? "active" : ""}`}
                    style={{
                      background: tab === t.id ? "#fff" : "transparent",
                      color: tab === t.id ? "var(--primary)" : "rgba(255,255,255,.7)",
                      borderRadius: "6px 6px 0 0",
                      fontFamily: "Poppins,sans-serif", fontSize: 13, fontWeight: 500, padding: "10px 18px",
                    }}
                    onClick={() => setTab(t.id)}
                  >
                    <i className={`bi ${t.icon}`} />{t.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="modal-body">
            {serverError && (
              <div className="alert alert-danger d-flex justify-content-between align-items-start" role="alert" style={{ fontSize: 13 }}>
                <div><i className="bi bi-exclamation-triangle-fill me-2" />{serverError}</div>
                {clearServerError && (
                  <button type="button" className="btn-close" onClick={clearServerError} style={{ fontSize: 10 }} />
                )}
              </div>
            )}

            {tab === "dados" && (
              <>
                <div className="form-section">
                  <div className="form-section-title"><i className="bi bi-building" /> Identificação</div>
                  <div className="row g-3">
                    <div className="col-md-3">
                      <label className="form-label">Tipo de Pessoa</label>
                      <select className="form-select" value={form.tpPessoa} onChange={(e) => { set("tpPessoa", e.target.value); set("cpf_cnpj", ""); setCnpjMsg(null); }}>
                        <option value="Juridica">Jurídica</option>
                        <option value="Fisica">Física</option>
                      </select>
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">{form.tpPessoa === "Fisica" ? "CPF" : "CNPJ"}</label>
                      <div className="input-group">
                        <input
                          className={`form-control ${errors.cpf_cnpj ? "is-invalid" : ""}`}
                          value={form.cpf_cnpj}
                          onChange={(e) => set("cpf_cnpj", fmtDoc(e.target.value))}
                          placeholder={form.tpPessoa === "Fisica" ? "000.000.000-00" : "00.000.000/0001-00"}
                        />
                        {form.tpPessoa === "Juridica" && (
                          <button
                            className="btn btn-outline-secondary"
                            type="button"
                            title="Preencher dados via Receita Federal"
                            onClick={buscarCNPJ}
                            disabled={cnpjLoading}
                          >
                            {cnpjLoading
                              ? <span className="spinner-border spinner-border-sm" />
                              : <><i className="bi bi-cloud-download me-1" />Receita</>}
                          </button>
                        )}
                        {errors.cpf_cnpj && <div className="invalid-feedback d-block">{errors.cpf_cnpj}</div>}
                      </div>
                      {cnpjMsg && (
                        <div
                          className={`small mt-1 ${cnpjMsg.tp === "ok" ? "text-success" : cnpjMsg.tp === "err" ? "text-danger" : "text-warning"}`}
                          style={{ fontSize: 11.5 }}
                        >
                          <i className={`bi ${cnpjMsg.tp === "ok" ? "bi-check-circle" : cnpjMsg.tp === "err" ? "bi-exclamation-circle" : "bi-info-circle"} me-1`} />
                          {cnpjMsg.msg}
                        </div>
                      )}
                    </div>
                    <div className="col-md-5">
                      <label className="form-label">{form.tpPessoa === "Fisica" ? "Nome Completo" : "Razão Social"} <span className="required-mark">*</span></label>
                      <input
                        className={`form-control ${errors.nmRazaoSocial ? "is-invalid" : ""}`}
                        value={form.nmRazaoSocial}
                        onChange={(e) => set("nmRazaoSocial", e.target.value)}
                        placeholder={form.tpPessoa === "Fisica" ? "Nome completo" : "Razão social completa"}
                      />
                      {errors.nmRazaoSocial && <div className="invalid-feedback">{errors.nmRazaoSocial}</div>}
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">{form.tpPessoa === "Fisica" ? "Apelido" : "Nome Fantasia"}</label>
                      <input className="form-control" value={form.nmReduzido} onChange={(e) => set("nmReduzido", e.target.value)} placeholder={form.tpPessoa === "Fisica" ? "Apelido / nome curto" : "Nome fantasia"} />
                    </div>
                    {form.tpPessoa === "Juridica" && (
                      <div className="col-md-3"><label className="form-label">Insc. Estadual</label><input className="form-control" value={form.inscEstadual} onChange={(e) => set("inscEstadual", e.target.value)} /></div>
                    )}
                    {form.tpPessoa === "Fisica" && (
                      <div className="col-md-3"><label className="form-label">RG</label><input className="form-control" value={form.rg} onChange={(e) => set("rg", e.target.value)} /></div>
                    )}
                    <div className="col-md-3">
                      <label className="form-label">Ramo de Atividade</label>
                      <input className="form-control" value={form.ramoAtividade} onChange={(e) => set("ramoAtividade", e.target.value)} placeholder="Ex: Manutenção, Limpeza..." />
                    </div>
                    <div className="col-md-2">
                      <label className="form-label">Situação</label>
                      <select className="form-select" value={form.situacao} onChange={(e) => set("situacao", e.target.value)}>
                        <option value="ativo">Ativo</option>
                        <option value="inativo">Inativo</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div className="form-section">
                  <div className="form-section-title"><i className="bi bi-telephone" /> Contato</div>
                  <div className="row g-3">
                    <div className="col-md-3"><label className="form-label">Telefone</label><input className="form-control" value={form.telefone} onChange={(e) => set("telefone", fmtPhone(e.target.value))} placeholder="(00) 0000-0000" /></div>
                    <div className="col-md-3"><label className="form-label">Celular</label><input className="form-control" value={form.celular} onChange={(e) => set("celular", fmtPhone(e.target.value))} placeholder="(00) 00000-0000" /></div>
                    <div className="col-md-4">
                      <label className="form-label">E-mail</label>
                      <input
                        className={`form-control ${errors.email ? "is-invalid" : ""}`}
                        type="email"
                        value={form.email}
                        onChange={(e) => set("email", e.target.value)}
                      />
                      {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                    </div>
                    <div className="col-md-4"><label className="form-label">Site</label><input className="form-control" value={form.site} onChange={(e) => set("site", e.target.value)} placeholder="www.fornecedor.com.br" /></div>
                    <div className="col-md-4"><label className="form-label">Contato</label><input className="form-control" value={form.contato} onChange={(e) => set("contato", e.target.value)} placeholder="Nome do responsável" /></div>
                    <div className="col-12"><label className="form-label">Observações</label><textarea className="form-control" rows={2} value={form.observacao} onChange={(e) => set("observacao", e.target.value)} /></div>
                  </div>
                </div>

                <div className="form-section">
                  <div className="form-section-title"><i className="bi bi-file-text" /> Dados Fiscais</div>
                  <div className="row g-3">
                    <div className="col-md-4"><label className="form-label">Nº INSS</label><input className="form-control" value={form.nrInss} onChange={(e) => set("nrInss", e.target.value)} /></div>
                    <div className="col-md-4"><label className="form-label">Nº PIS</label><input className="form-control" value={form.nrPis} onChange={(e) => set("nrPis", e.target.value)} /></div>
                  </div>
                </div>
              </>
            )}

            {tab === "endereco" && (
              <div className="form-section">
                <div className="form-section-title"><i className="bi bi-geo-alt" /> Endereço</div>
                <div className="row g-3">
                  <div className="col-md-3">
                    <label className="form-label">CEP</label>
                    <div className="input-group">
                      <input
                        className="form-control"
                        value={form.cep}
                        onChange={(e) => set("cep", fmtCEP(e.target.value))}
                        onBlur={(e) => buscarCEP(e.target.value)}
                        placeholder="00000-000" maxLength={9}
                      />
                      <button className="btn btn-outline-secondary" type="button" onClick={() => buscarCEP(form.cep)} disabled={cepLoading}>
                        {cepLoading ? <span className="spinner-border spinner-border-sm" /> : <i className="bi bi-search" />}
                      </button>
                    </div>
                  </div>
                  <div className="col-md-5"><label className="form-label">Endereço</label><input className="form-control" value={form.endereco} onChange={(e) => set("endereco", e.target.value)} /></div>
                  <div className="col-md-2"><label className="form-label">Número</label><input className="form-control" value={form.numero} onChange={(e) => set("numero", e.target.value)} /></div>
                  <div className="col-md-2"><label className="form-label">Complemento</label><input className="form-control" value={form.complemento} onChange={(e) => set("complemento", e.target.value)} /></div>
                  <div className="col-md-4"><label className="form-label">Bairro</label><input className="form-control" value={form.bairro} onChange={(e) => set("bairro", e.target.value)} /></div>
                  <div className="col-md-4"><label className="form-label">Cidade</label><input className="form-control" value={form.cidade} onChange={(e) => set("cidade", e.target.value)} /></div>
                  <div className="col-md-2">
                    <label className="form-label">Estado</label>
                    <select className="form-select" value={form.estado} onChange={(e) => set("estado", e.target.value)}>
                      {estadosBR.map((uf) => <option key={uf}>{uf}</option>)}
                    </select>
                  </div>
                </div>
              </div>
            )}

            {tab === "bancario" && (
              <>
                <div className="form-section">
                  <div className="form-section-title"><i className="bi bi-bank" /> Dados Bancários</div>
                  <div className="row g-3">
                    <div className="col-md-3"><label className="form-label">Código do Banco</label><input className="form-control" value={form.codBanco} onChange={(e) => set("codBanco", e.target.value.replace(/\D/g, "").slice(0, 4))} placeholder="Ex: 001" /></div>
                    <div className="col-md-3"><label className="form-label">Agência</label><input className="form-control" value={form.agencia} onChange={(e) => set("agencia", e.target.value)} /></div>
                    <div className="col-md-2"><label className="form-label">Dígito Ag.</label><input className="form-control" value={form.dgAgencia} onChange={(e) => set("dgAgencia", e.target.value)} placeholder="Dígito" /></div>
                    <div className="col-md-3"><label className="form-label">Conta Corrente</label><input className="form-control" value={form.contCorrente} onChange={(e) => set("contCorrente", e.target.value)} /></div>
                    <div className="col-md-2"><label className="form-label">Dígito CC</label><input className="form-control" value={form.dgContaCorrente} onChange={(e) => set("dgContaCorrente", e.target.value)} placeholder="Dígito" /></div>
                  </div>
                </div>
                <div className="form-section">
                  <div className="form-section-title"><i className="bi bi-qr-code" /> PIX</div>
                  <div className="row g-3">
                    <div className="col-md-6">
                      <label className="form-label">Chave PIX</label>
                      <input
                        className="form-control"
                        value={form.chavePix}
                        onChange={(e) => set("chavePix", e.target.value)}
                        placeholder="CPF, CNPJ, e-mail, telefone ou chave aleatória"
                      />
                    </div>
                    <div className="col-md-6 d-flex align-items-end">
                      <div style={{ background:"var(--bg-success-soft)", border: "1px solid #BBF7D0", borderRadius: 8, padding: "10px 14px", fontSize: 12, color: "#166534" }}>
                        <i className="bi bi-info-circle me-2" />A chave PIX será usada para pagamentos ao fornecedor.
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>

          <div className="modal-footer d-flex justify-content-between">
            <div style={{ fontSize: 12, color: "var(--gray-400)" }}>
              <i className="bi bi-asterisk me-1" style={{ color: "#ef4444", fontSize: 9 }} />Campos obrigatórios
            </div>
            <div className="d-flex gap-2">
              <button className="btn btn-outline-secondary" onClick={onClose}><i className="bi bi-x-circle" /> Cancelar</button>
              <button className="btn btn-primary" onClick={handleSave} disabled={saving}>
                {saving ? <><span className="spinner-border spinner-border-sm me-2" />Salvando...</> : <><i className="bi bi-check-circle" /> {isEdit ? "Salvar Alterações" : "Cadastrar"}</>}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
